import router from '../services/router_service';
import companyController from '../controllers/company_controller';

router.on('route:company', companyController);
